// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".elevation-1[data-v-deda074a]{margin:20px;text-align:center}", ""]);
// Exports
module.exports = exports;
